var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", "z-index": "600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-chip",
                _vm._g(
                  { attrs: { color: _vm.color, "text-color": _vm.textColor } },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "small mr-1 my-2" }, [
                    _vm._v("fa-plane-departure")
                  ]),
                  _vm._v(_vm._s(_vm.text))
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("travelService.types.flight")) +
                " (" +
                _vm._s(_vm.$t("global.request")) +
                ")"
            )
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.departureAirport")) +
              ": " +
              _vm._s(_vm.startPlaceText)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.arrivalAirport")) +
              ": " +
              _vm._s(_vm.endPlaceText)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.class")) +
              ": " +
              _vm._s(_vm.seatClassText) +
              " "
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.registeredBaggageWillBeAssigned")) +
              " "
          ),
          _vm.travelServiceOrderItem.flight.is_baggage === 1
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.startFlightDate")) +
              ": " +
              _vm._s(_vm.travelServiceOrderItem.flight.start_date) +
              " " +
              _vm._s(_vm.travelServiceOrderItem.flight.start_time) +
              " "
          ),
          _c("br"),
          _vm._v(" " + _vm._s(_vm.$t("travelService.isReturnRoute")) + " "),
          _vm.travelServiceOrderItem.flight.return_date !== null
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _vm.travelServiceOrderItem.flight.additionalSegments.length > 0
            ? _c(
                "span",
                [
                  _c("v-icon", { attrs: { small: "", color: "success" } }, [
                    _vm._v("fa-bezier-curve")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("travelService.additionalSegments")) +
                      " "
                  )
                ],
                1
              )
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br"),
          _vm.travelServiceOrderItem.flight.return_date !== null
            ? [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("travelService.returnFlightDate")) +
                    ": " +
                    _vm._s(_vm.travelServiceOrderItem.flight.return_date) +
                    " " +
                    _vm._s(_vm.travelServiceOrderItem.flight.return_time)
                ),
                _c("br")
              ]
            : _vm._e(),
          _c("travel-service-order-item-common-tooltip-part", {
            attrs: { "travel-service-order-item": _vm.travelServiceOrderItem }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }